import React from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

const DashboardMenu = ({
  actMenu = "bookings",
  setActMenu = (v = '') => { console.error(`setActMenu not defined DashboardMenu ${v}`) },
  setLoggedIn = (v = '') => { console.error(`setLoggedIn not defined DashboardMenu ${v}`) }
}) => {
  return (
    <div className="dashboard-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-menu">
              <ul>
                <li className="d-none">
                  <Link
                    to=""
                    className={actMenu === "dashboard" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setActMenu('dashboard');
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/dashboard-icon.svg"
                      alt="Icon"
                    />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    className={actMenu === "bookings" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setActMenu('bookings');
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/booking-icon.svg"
                      alt="Icon"
                    />
                    <span>My Bookings</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    className={actMenu === "reviews" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setActMenu('reviews');
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/review-icon.svg"
                      alt="Icon"
                    />
                    <span>Reviews</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    className={actMenu === "payments" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setActMenu('payments');
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/payment-icon.svg"
                      alt="Icon"
                    />
                    <span>Payments</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    className={actMenu === "settings" ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setActMenu('settings');
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/settings-icon.svg"
                      alt="Icon"
                    />
                    <span>Profile Settings</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to=""
                    onClick={(e) => {
                      e.preventDefault();
                      localStorage.removeItem('uToken');
                      setLoggedIn(false);
                    }}
                  >
                    <i 
                      className="fa fa-sign-out fa-3x"
                    />
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardMenu.propTypes = {
  setActMenu: PropTypes.func.isRequired,
  setLoggedIn: PropTypes.func.isRequired,
  actMenu: PropTypes.any.isRequired,
};

export default DashboardMenu;
